import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 2rem;
  padding: 1.5rem 2rem;

  @media ${mq(sizes.tablet)} {
    padding: 1.8rem 2.5rem;
  }
`

export const Text = styled.div`
  text-align: center;
  ${({ theme }) => theme.textStyles.text_16};
  /* font-size: 2rem; */
  color: ${({ theme }) => theme.colors.familyBurgundy};

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.text_medium_18};
  }
`
